import { createFileRoute } from '@tanstack/react-router';
import { SetPasswordPage } from '@/auth/SetPasswordPage';

// Public — the recipient may have no (or a stale) session. Token validity is
// only knowable server-side; an empty/missing token renders the error panel.
export const Route = createFileRoute('/reset-password')({
  // Route-data exemption: unauthenticated, driven entirely by the token in the URL.
  validateSearch: (search: Record<string, unknown>): { token: string } => ({
    token: typeof search.token === 'string' ? search.token : '',
  }),
  component: Page,
});

function Page() {
  const { token } = Route.useSearch();
  return <SetPasswordPage mode="reset" token={token} />;
}
